/* Product page interactions: image gallery, variant picker, quantity stepper */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initGalleries();
    initQuantitySteppers();
    initVariantPickers();
  });

  /* --- Thumbnail gallery --- */
  function initGalleries() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      var prevBtn = gallery.querySelector('[data-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-gallery-next]');
      var thumbPrevBtn = gallery.querySelector('[data-thumb-arrow-prev]');
      var thumbNextBtn = gallery.querySelector('[data-thumb-arrow-next]');
      var thumbsContainer = gallery.querySelector('[data-thumbs-container]') || gallery.querySelector('.product-gallery__thumbs');

      function activateIndex(index) {
        if (index < 0) index = thumbs.length - 1;
        if (index >= thumbs.length) index = 0;
        
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        if (thumbs[index]) {
          thumbs[index].classList.add('is-active');
          var targetId = thumbs[index].getAttribute('data-target');
          slides.forEach(function (slide) {
            slide.classList.toggle('is-active', slide.id === targetId);
          });

          // Smoothly scroll the active thumbnail into center view
          if (thumbsContainer) {
            var thumb = thumbs[index];
            var containerWidth = thumbsContainer.clientWidth;
            var thumbLeft = thumb.offsetLeft;
            var thumbWidth = thumb.offsetWidth;
            var targetScroll = thumbLeft - (containerWidth / 2) + (thumbWidth / 2);
            thumbsContainer.scrollTo({ left: targetScroll, behavior: 'smooth' });
          }
        }
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          activateIndex(index);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var activeIndex = Array.from(thumbs).findIndex(function(t) { return t.classList.contains('is-active'); });
          activateIndex(activeIndex - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var activeIndex = Array.from(thumbs).findIndex(function(t) { return t.classList.contains('is-active'); });
          activateIndex(activeIndex + 1);
        });
      }

      /* --- Thumbnail Arrow Navigation (Left & Right) --- */
      if (thumbPrevBtn && thumbsContainer) {
        thumbPrevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var scrollAmount = Math.max(160, thumbsContainer.clientWidth * 0.75);
          thumbsContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
      }

      if (thumbNextBtn && thumbsContainer) {
        thumbNextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var scrollAmount = Math.max(160, thumbsContainer.clientWidth * 0.75);
          thumbsContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      }

      function updateThumbArrows() {
        if (!thumbsContainer || !thumbPrevBtn || !thumbNextBtn) return;
        var maxScroll = thumbsContainer.scrollWidth - thumbsContainer.clientWidth;
        if (maxScroll <= 4) {
          thumbPrevBtn.style.display = 'none';
          thumbNextBtn.style.display = 'none';
          return;
        } else {
          thumbPrevBtn.style.display = 'flex';
          thumbNextBtn.style.display = 'flex';
        }

        var sl = thumbsContainer.scrollLeft;
        var atStart = sl <= 2;
        var atEnd = sl >= maxScroll - 2;

        thumbPrevBtn.disabled = atStart;
        thumbPrevBtn.classList.toggle('is-disabled', atStart);

        thumbNextBtn.disabled = atEnd;
        thumbNextBtn.classList.toggle('is-disabled', atEnd);
      }

      if (thumbsContainer) {
        thumbsContainer.addEventListener('scroll', updateThumbArrows, { passive: true });
        window.addEventListener('resize', updateThumbArrows);
        setTimeout(updateThumbArrows, 150);
        setTimeout(updateThumbArrows, 600);
      }

      /* --- Touch Swipe Support for Mobile --- */
      var mainArea = gallery.querySelector('.product-gallery__main') || gallery;
      var touchStartX = 0;
      var touchStartY = 0;
      var touchEndX = 0;
      var touchEndY = 0;

      mainArea.addEventListener('touchstart', function (e) {
        if (e.touches && e.touches.length === 1) {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }
      }, { passive: true });

      mainArea.addEventListener('touchend', function (e) {
        if (e.changedTouches && e.changedTouches.length === 1) {
          touchEndX = e.changedTouches[0].clientX;
          touchEndY = e.changedTouches[0].clientY;
          
          var diffX = touchEndX - touchStartX;
          var diffY = touchEndY - touchStartY;

          // Only trigger if horizontal swipe is dominant and moved at least 35px
          if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 35) {
            var activeIndex = Array.from(thumbs).findIndex(function(t) { return t.classList.contains('is-active'); });
            if (diffX < 0) {
              // Swiped Left -> Next Image
              activateIndex(activeIndex + 1);
            } else {
              // Swiped Right -> Previous Image
              activateIndex(activeIndex - 1);
            }
          }
        }
      }, { passive: true });
    });
  }

  function showMediaById(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    var targetId = 'ProductMedia-' + mediaId;
    var thumb = gallery.querySelector('[data-gallery-thumb][data-target="' + targetId + '"]');
    if (thumb) thumb.click();
  }

  /* --- Quantity +/- buttons --- */
  function initQuantitySteppers() {
    document.querySelectorAll('.quantity-input').forEach(function (wrap) {
      var input = wrap.querySelector('[data-quantity-input]');
      var minus = wrap.querySelector('[data-quantity-minus]');
      var plus = wrap.querySelector('[data-quantity-plus]');
      if (!input) return;

      minus && minus.addEventListener('click', function () {
        var min = parseInt(input.min || '1', 10);
        var value = Math.max(min, (parseInt(input.value, 10) || min) - 1);
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      plus && plus.addEventListener('click', function () {
        var value = (parseInt(input.value, 10) || 1) + 1;
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* --- Variant picker --- */
  function initVariantPickers() {
    document.querySelectorAll('.product-form').forEach(function (form) {
      var section = form.closest('[data-product-gallery]') ? form.parentElement : form.parentElement;
      var wrapper = form.closest('.product-template') || document;

      var dataScript = wrapper.querySelector('script[id^="ProductVariantData-"]');
      if (!dataScript) return;

      var data;
      try {
        data = JSON.parse(dataScript.textContent);
      } catch (e) {
        return;
      }

      var variants = data.variants || [];
      var optionInputs = wrapper.querySelectorAll('[data-option-value], [data-color-swatch]');
      var hiddenIdInput = form.querySelector('#ProductSelectedVariant');
      var priceWrap = wrapper.querySelector('#ProductPrice');
      var addToCartBtn = wrapper.querySelector('[data-add-to-cart]');
      var addToCartText = wrapper.querySelector('[data-add-to-cart-text]');
      var gallery = wrapper.querySelector('[data-product-gallery]');

      function getSelectedOptions() {
        var groups = wrapper.querySelectorAll('.product-option');
        var selected = [];
        
        // Start with the default options from the current selected or first variant
        var firstVariant = variants[0];
        if (firstVariant) {
          firstVariant.options.forEach(function(opt, idx) {
            selected[idx] = opt;
          });
        }

        groups.forEach(function (group) {
          var position = parseInt(group.getAttribute('data-option-position'), 10);
          var active = group.querySelector('.is-active[data-value]');
          if (active) {
            selected[position - 1] = active.getAttribute('data-value');
          }
        });
        return selected;
      }

      function findMatchingVariant(selected) {
        return variants.find(function (variant) {
          return variant.options.every(function (opt, i) {
            return selected[i] == null || opt === selected[i];
          });
        });
      }

      function updateUI(variant) {
        if (!variant) return;

        if (hiddenIdInput) hiddenIdInput.value = variant.id;

        if (priceWrap) {
          var regular = priceWrap.querySelector('.price-item--regular');
          var sale = priceWrap.querySelector('.price-item--sale');
          if (variant.compare_at_price && variant.compare_at_price !== variant.price) {
            if (regular) { regular.textContent = variant.compare_at_price; regular.style.display = ''; }
            if (sale) { sale.textContent = variant.price; sale.style.display = ''; }
          } else if (regular) {
            regular.textContent = variant.price;
          }
        }

        if (addToCartBtn) {
          addToCartBtn.disabled = !variant.available;
        }
        if (addToCartText) {
          addToCartText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        }

        if (gallery && variant.featured_media_id) {
          showMediaById(gallery, variant.featured_media_id);
        }
      }

      optionInputs.forEach(function (input) {
        input.addEventListener('click', function () {
          var group = input.closest('.product-option');
          if (!group) return;

          group.querySelectorAll('[data-value]').forEach(function (el) {
            el.classList.remove('is-active');
            el.setAttribute('aria-pressed', 'false');
          });
          input.classList.add('is-active');
          input.setAttribute('aria-pressed', 'true');

          var label = group.querySelector('[data-option-selected-value]');
          if (label) label.textContent = input.getAttribute('data-value');

          var variant = findMatchingVariant(getSelectedOptions());
          updateUI(variant);
        });
      });
    });
  }
})();
